import type { PersonalLoanRequest, PersonalLoanResponseItem } from "../types";

export function convertProvidentData(
	_request: PersonalLoanRequest,
	response: PersonalLoanResponseItem,
): PersonalLoanResponseItem {
	const productData = { ...response };

	switch (productData.name) {
		case "Provident Kölcsön – 110 hetes futamidővel":
			productData.weeklyStartInstallment = productData.startInstallment / 3.354376679;
			productData.totalRedemption = productData.weeklyStartInstallment * 110;
			break;
		case "Provident Kölcsön – 57 hetes futamidővel":
			productData.weeklyStartInstallment = productData.startInstallment / 4.731443574;
			productData.totalRedemption = productData.weeklyStartInstallment * 57;
			break;
		case "Provident Maxi Kölcsön":
			productData.totalRedemption = productData.startInstallment * 30;
			break;
		default:
			break;
	}

	return productData;
}
